module.exports = __webpack_public_path__ + "img/南方投资.91bf53b9.png";